import { connect } from 'react-redux';
import { get } from 'lodash';

import PageSupportBlock from './page-support-block.component';

export interface IPageSupportBlockStoreProps {
    readonly faqUrl?: string;
}

const mapStateToProps = (state: object): IPageSupportBlockStoreProps => {
    return { faqUrl: get(state, 'config.links.faq', '') };
};

export const PageSupportBlockContainer = connect(mapStateToProps)(PageSupportBlock);
